export const TABLE_COLUMN_CLASSNAMES = {
  attribute: "w-[140px]",
  trait: "w-[140px] grow",
  count: "w-[120px] justify-end whitespace-nowrap",
  floor: "w-[130px] justify-end whitespace-nowrap",
  topOffer: "w-[130px] justify-end whitespace-nowrap",
}
